import {
  Button,
  Icons,
  Panel,
  tokens,
  Stack,
  Typography,
} from '@cast/design-system';

type Props = {
  title: string;
  onRetry: () => void;
};

export const ErrorPanel = ({ title, onRetry }: Props) => {
  return (
    <Panel>
      <Stack
        alignItems="center"
        justifyContent="center"
        gap={8}
        sx={{ py: 24, px: 32 }}
      >
        <Typography variant="A1">{title}</Typography>
        <Typography
          variant="P12R"
          sx={{ color: tokens.theme.fg.structural.secondary }}
        >
          Something went wrong.
        </Typography>
        <Stack direction="row" gap={8}>
          <Button
            variant="text"
            startIcon={<Icons.ArrowsCounterClockwise />}
            onClick={onRetry}
          >
            Try again
          </Button>
        </Stack>
      </Stack>
    </Panel>
  );
};
